import { Alert } from '@capsicum/common-web';
import { useNCWTestBeforeSendAlert } from '@capsicum/features/nc-wallet/shared';

import { CustomInfoIcon } from './CustomInfoIcon';

export const NCWTestBeforeSendAlert = () => {
	const { intlText } = useNCWTestBeforeSendAlert();

	return (
		<Alert
			closable={false}
			icon={CustomInfoIcon}
			subTitle={intlText.infoSubtitle}
			title={intlText.infoTitle}
			type="message"
		/>
	);
};
